import { Trans } from '@lingui/macro'
import * as React from 'react'

import { useBreakpoints } from '@emico/ui'

import styles from './CartPageOrderSummary.module.scss'
import { useIsJustRewardsEnabled } from '../../account-dashboard-page/AccountDashboardPageLayout/justRewards/isJustRewardsEnabled'
import { SidebarStickyButton } from '../../checkout/Sidebar/SidebarStickyButton'
import Button from '../../input/Button'
import FeedbackMessage from '../../input/SuccessMessage'
import Separator from '../../layout/Separator'
import paths from '../../paths'
import PaymentMethods from '../../presentation/AvailablePaymentMethods'
import Heading from '../../typography/Heading'
import useIsCheckoutAccessible from '../../useIsCheckoutAccessible'
import overridable from '../../utils/overridable'
import { CustomerCouponVouchers } from '../../vouchers/CustomerCouponVouchers'
import { CtaButton } from '../CartPage/CtaButton'
import { Totals } from '../CartTotals/Totals'
import Coupon from '../Coupon'

interface Props {
    className?: string
}

export const CartPageOrderSummary = ({ className }: Props) => {
    const canCheckout = useIsCheckoutAccessible()

    const showVouchers = useIsJustRewardsEnabled()
    const { isMobile } = useBreakpoints()

    return (
        <aside className={className}>
            {showVouchers && isMobile && (
                <>
                    <FeedbackMessage />
                    <div className={styles.vouchers}>
                        <CustomerCouponVouchers />
                    </div>
                    <div className={styles.ctaButton}>
                        <CtaButton />
                    </div>
                </>
            )}
            <Heading
                variant="h2"
                element="h1"
                color="dark"
                className={styles.title}
            >
                <Trans id="cart.orderSummary.heading">Overview</Trans>
            </Heading>

            <Separator />

            <Totals />

            <SidebarStickyButton>
                <Button
                    to={paths.checkout}
                    variant="highlight"
                    wide
                    disabled={!canCheckout}
                    name="Checkout"
                    category="cart.orderSummary.checkout"
                    data-testid="cart.placeOrder"
                >
                    <Trans id="cart.orderSummary.checkoutButtonLabel">
                        Checkout
                    </Trans>
                </Button>
            </SidebarStickyButton>

            <div className={styles.weAccept}>
                <PaymentMethods />
            </div>

            <Coupon />
        </aside>
    )
}

export default overridable('CartPageOrderSummary')(
    CartPageOrderSummary,
) as React.ComponentType<Props>
